export default __webpack_public_path__ + "static/media/biokonwersja_odpadu.f9e006f1.png";